gsap.registerPlugin(ScrollTrigger,Observer);



class TextAnimation {
    constructor() {
        this.options = { root: null, rootMargin: "0px", threshold: [0.15] };
        this.observe = new IntersectionObserver( entries => this.observeEntries(entries) ,this.options);
        this.sections = document.querySelectorAll('.animate-container');
        this.observers = this.sectionObserver;
        
    }

    get sectionObserver() {
        return  Array.from(this.sections).forEach(section => this.observe.observe(section));
    }

    observeEntries(entries) {
        Array.from(entries).forEach( entry => {
            if (entry.isIntersecting) {  
                const { target } = entry;
                const text = target.querySelectorAll('.word-wrap div');
                const overlay = target.querySelectorAll('.image-overlay')
                if (text.length && !target.animated) {
                    this.animateText(text);
                    target.animated = true;
                }
                if(overlay) this.animateOverlay(overlay)
            }
         
        })
    }


    animateText(text) {
        console.log('ggg')
        gsap.to(text, {
            transform: "translateY(0%)",
            stagger:0.1,
            duration: 1,
            ease: "power3.out",
            lazy: true 
        })
      
    }
    animateOverlay(overlay) {
        gsap.to(overlay, {
            xPercent: 100,
            duration: 2,
            ease: "power3.out",
            lazy: true 
        })
    }
}


const animation = new TextAnimation();
